import React from 'react';

const SewonMinTwitterUserDescription = () => {
  return (
    <div
      dir="auto"
      className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41"
      data-testid="UserDescription"
      style={{ color: 'rgb(15, 20, 25)' }}
    >
      <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3">Incoming faculty </span>
      <div className="css-175oi2r r-xoduu5">
        <span className="r-18u37iz">
          <a
            dir="ltr"
            href="/Berkeley_EECS"
            role="link"
            className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1loqt21"
            style={{ color: 'rgb(29, 155, 240)' }}
          >
            @Berkeley_EECS
          </a>
        </span>
      </div>
      <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3"> </span>
      <div className="css-175oi2r r-xoduu5">
        <span className="r-18u37iz">
          <a
            dir="ltr"
            href="/berkeley_ai"
            role="link"
            className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1loqt21"
            style={{ color: 'rgb(29, 155, 240)' }}
          >
            @berkeley_ai
          </a>
        </span>
      </div>
      <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3"> || Research scientist at </span>
      <div className="css-175oi2r r-xoduu5">
        <span className="r-18u37iz">
          <a
            dir="ltr"
            href="/allen_ai"
            role="link"
            className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1loqt21"
            style={{ color: 'rgb(29, 155, 240)' }}
          >
            @allen_ai
          </a>
        </span>
      </div>
      <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3"> || PhD from </span>
      <div className="css-175oi2r r-xoduu5">
        <span className="r-18u37iz">
          <a
            dir="ltr"
            href="/uwcse"
            role="link"
            className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1loqt21"
            style={{ color: 'rgb(29, 155, 240)' }}
          >
            @uwcse
          </a>
        </span>
      </div>
      <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3"> </span>
      <div className="css-175oi2r r-xoduu5">
        <span className="r-18u37iz">
          <a
            dir="ltr"
            href="/uwnlp"
            role="link"
            className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1loqt21"
            style={{ color: 'rgb(29, 155, 240)' }}
          >
            @uwnlp
          </a>
        </span>
      </div>
    </div>
  );
};

export default SewonMinTwitterUserDescription;
